"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getYPosition = function getYPosition(positionString, top, height) {
  switch (positionString) {
    case 'top':
      return top;

    case 'bottom':
      return top + height;

    default:
      return top + height / 2;
  }
};

var getXPosition = function getXPosition(positionString, left, width) {
  switch (positionString) {
    case 'left':
      return left;

    case 'right':
      return left + width;

    default:
      return left + width / 2;
  }
};

var _default = function _default(position, _ref) {
  var top = _ref.top,
      left = _ref.left,
      width = _ref.width,
      height = _ref.height;
  var positionSplit = position.split(' ');
  var positionSplitA = positionSplit[0];
  var positionSplitB = positionSplit[1] || positionSplitA;

  if (positionSplitA === 'left' || positionSplitA === 'right') {
    var positionA = positionSplitA;
    positionSplitA = positionSplitB;
    positionSplitB = positionA;
  }

  return {
    top: getYPosition(positionSplitA, top, height),
    left: getXPosition(positionSplitB, left, width)
  };
};

exports.default = _default;
module.exports = exports.default;